import { AudiencePage } from "@/components/sections/AudiencePage";
import { VERTICALS } from "@/lib/content";
import SEO from "@/components/common/SEO";

const points = [
  {
    icon: "Target",
    title: "Hire with intent",
    body: "Recruitment and sourcing built around the role you actually need to fill, not a generic pipeline.",
  },
  {
    icon: "Building2",
    title: "Scale hiring cleanly",
    body: "RPO and workforce planning that give you structure and capacity without adding permanent overhead.",
  },
  {
    icon: "ClipboardCheck",
    title: "Strengthen your HR",
    body: "Practical HR consulting and talent strategy that fit how your organisation really operates.",
  },
];

export default function ForEmployers() {
  const verticals = VERTICALS.filter(
    (v) => v.id === "people-hr" || v.id === "ai-digital"
  );

  return (
    <>
      <SEO
        title="Recruitment & HR Consulting for Employers | Success Crest Consulting"
        description="Success Crest Consulting helps employers with recruitment, candidate sourcing, RPO, workforce planning, HR consulting, talent strategy, and AI-powered business solutions."
        path="/for-employers"
      />

      <AudiencePage
        testId="for-employers-page"
        overline="For Employers"
        title="Build the team your business deserves."
        subtitle="Whether you’re hiring your first key role or rethinking how you attract talent at scale, SCC brings deliberate People & HR and digital capability to the table."
        points={points}
        verticals={verticals}
        ctaPath="employers"
        ctaLabel="Tell Us What You Need"
      />
    </>
  );
}
